// CareLogix™ ORACLE — Phase 33 API client (predictive, altdata, guard, funding, jobs, architecture)
import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

const MEMBER_TOKEN_KEYS = [
  "carelogix_member_token",
  "oracle.auth.token",
  "oracle.session_token",
];
const ADMIN_TOKEN_KEYS = [
  "carelogix_adminone_token",
  "oracle.adminone.token",
  "adminone.token",
  "adminone_jwt",
];

function readToken(keys) {
  if (typeof window === "undefined") return null;
  for (const k of keys) {
    try { const v = window.localStorage.getItem(k); if (v) return v; } catch (_) { /* ignore */ }
  }
  return null;
}

const publicHttp = axios.create({ baseURL: `${BASE}/api/oracle`, timeout: 25_000 });
publicHttp.interceptors.request.use((cfg) => {
  const t = readToken(MEMBER_TOKEN_KEYS);
  if (t && cfg && cfg.headers) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const adminHttp = axios.create({ baseURL: `${BASE}/api/adminone`, timeout: 30_000 });
adminHttp.interceptors.request.use((cfg) => {
  const t = readToken(ADMIN_TOKEN_KEYS);
  if (t && cfg && cfg.headers) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const predictiveApi = {
  signal: (symbol, domain) => publicHttp.get("/predictive/signal", { params: { symbol, domain: domain || "stocks" } }),
  cards:  (symbols, domain) => publicHttp.get("/predictive/cards",  { params: { symbols: (symbols || []).join(","), domain: domain || "stocks" } }),
};

export const altDataApi = {
  sources: () => publicHttp.get("/altdata/sources"),
  intel:   (symbol, domain) => publicHttp.get("/altdata/intel", { params: { symbol, domain: domain || "stocks" } }),
};

export const guardApi = {
  catalog: () => publicHttp.get("/guard/catalog"),
  scan:    (text, surface) => publicHttp.post("/guard/scan", { text, surface: surface || "console" }),
};

export const fundingApi = {
  catalog:      () => publicHttp.get("/funding/catalog"),
  opportunities:(params) => publicHttp.get("/funding/opportunities", { params: params || {} }),
  byId:         (id) => publicHttp.get(`/funding/opportunity/${encodeURIComponent(id)}`),
};

export const adminMarketAbuseApi = {
  events:  (params) => adminHttp.get("/market-abuse/events", { params: params || {} }),
  resolve: (eventId, action) => adminHttp.post(`/market-abuse/events/${encodeURIComponent(eventId)}`, null, { params: { action: action || "reviewed" } }),
};

export const adminFundingApi = {
  dashboard: (limit) => adminHttp.get("/funding/dashboard", { params: limit ? { limit } : undefined }),
};

export const adminJobsApi = {
  catalog: () => adminHttp.get("/jobs/catalog"),
  run:     (jobName, payload) => adminHttp.post(`/jobs/run/${encodeURIComponent(jobName)}`, payload || {}),
};

export const adminArchitectureApi = {
  snapshot:     () => adminHttp.get("/system/architecture"),
  recentEvents: (eventName, limit) => adminHttp.get(`/system/events/${encodeURIComponent(eventName)}`, { params: limit ? { limit } : undefined }),
};

export default {
  predictiveApi, altDataApi, guardApi, fundingApi,
  adminMarketAbuseApi, adminFundingApi, adminJobsApi, adminArchitectureApi,
};
